import React from 'react'
import PageAnimation from '@shared/components/page-animation'
import { Actioners } from '@shared/components/sections/actioners'
import { Feedback } from '@shared/components/sections/feedback'
import { ServicesInvestors } from '@shared/components/sections/services-investors'
import { Smi } from '@shared/components/sections/smi'

import { AboutYoutube } from './sections/about-youtube'
import { Directions } from './sections/directions'
import { Geo } from './sections/geo'
import { Journal } from './sections/journal'
import { LongHistory } from './sections/long-history'
import { OpennessAndResponsibility } from './sections/openness-and-responsibility'
import { OurMission } from './sections/our-mission'
import { OurValues } from './sections/our-values'
import { Profit } from './sections/profit'
import { Team } from './sections/team'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import { DEFAULT_CITY } from 'regions/list'

const Technologies = dynamic(() =>
	import('./sections/technologies').then(({ Technologies }) => Technologies)
)

const View = () => {
	return (
		<PageAnimation>
			<OurMission />
			<br />
			<Directions />
			<LongHistory />
			<ServicesInvestors />
			<Team />
			<Actioners />
			<OurValues />
			<Technologies />
			<Profit />
			<Feedback title='Мы — то, что о нас говорят' />
			<OpennessAndResponsibility />
			<Smi />
			<Journal />
			<AboutYoutube />
			<Geo />
		</PageAnimation>
	)
}

export default View
